document.addEventListener('turbolinks:load', function () {
  // ¥ 開発環境での開発スピードを上げるため青木の開発環境でのみ
  // ¥ manage/app/javascript/packs内の本jsファイルを走らせない
  if ((location.href.includes('dev-manage-ssl.platta.jp') || location.href.includes('http://18.177.103.115:3004')) && !location.href.includes('?dev27aoki')) {
    console.log('dev環境 public.jsを使用');
    return;
  }

  const ERROR_MSG = 'エラー！　処理を完了できませんでした\n時間おいて再度実行しても、このエラーが修正されない場合は\nお手数ですがサポートチームにお問い合わせください';
  const MAIL_PATTERN = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  const PASSWORD_PATTERN = /([0-9].*[a-zA-Z]|[a-zA-Z].*[0-9])/;

  const DOMAIN = $('#pl_domain').val();

  //- ハッシュタグ検索の初期の画面でフィルターをかける処理
  let current_url = window.location.href;

  // console.log("manual_my_post_display.js --- 20230622");

  // !!!!!!!!!!!!!!!!! ここから !!!!!!!!!!!!!!!!!!!!!!!!!

  //¥ ボタンを押下したタイミングで複数の選択されたタグ名及び検索タイプを配列で取得する
  $('#mas_submit, #mas_submit_2').on('click', function (e) {
    let mas_ugc_urls = $('#mas_ugc_urls').val();
    // ¥ 余分な空白等含む可能性あり
    let mas_ugc_urls_list = mas_ugc_urls.split('\n');
    // console.log("mas_ugc_urls_list:", mas_ugc_urls_list);

    // ¥ 要素についているかもしれない前後の空白除去及び 'https://~ ' や "https://~ "などの ' や "を削除"
    mas_ugc_urls_list = $.map(mas_ugc_urls_list, function (url, idx) {
      return url.replace(/'/g, '').replace(/"/g, '').replace(/,/g, '').trim();
    });

    // ¥ 20230423 ローカルストレージに保存する
    let mas_ugc_urls_list_str = JSON.stringify(mas_ugc_urls_list);
    localStorage.setItem(`mas_ugc_urls_list`, mas_ugc_urls_list_str);

    $.ajax({
      url: DOMAIN + '/mas_filter_own_post_ugc',
      type: 'GET',
      dataType: 'json',
      data: {
        // mas_ugc_urls_list: mas_ugc_urls_list,
        mas_ugc_urls_list: localStorage.getItem(`mas_ugc_urls_list`),
      },
    })
      .done(function (data_fr_ruby) {
        const filter_condition = mas_get_all_filter_condition();
        // ¥ &ugc_check=1 を url_query_path に加え、ボタンを押下したタイミングでのみのpath

        // let mas_url;
        // if (current_url.includes("/hashtag_list")) {
        //   mas_url = "/hashtag_list";
        // } else if (current_url.includes("/my_post_list")) {
        //   mas_url = "/my_post_list";
        // }

        let mas_url = '/manual_add_sns_post_display';

        url_query_path = `${mas_url}?initial_date=${filter_condition['initial_date']}&end_date=${filter_condition['end_date']}&search_condition=${filter_condition['search_condition']}&${filter_condition['excluded_words']}&per_page_num=${filter_condition['per_page_num']}&ugc_check=1`;

        let storage_mas_ugc_urls_list = localStorage.getItem(`mas_ugc_urls_list`);

        if (storage_mas_ugc_urls_list) {
          storage_mas_ugc_urls_list = JSON.parse(storage_mas_ugc_urls_list);
          storage_mas_ugc_urls_list = storage_mas_ugc_urls_list.join('\n');
          // console.log("storage_mas_ugc_urls_list", storage_mas_ugc_urls_list);
        }

        location.href = url_query_path;
      })
      .fail(function (jqXHR, textStatus, errorThrown) {});

    // ¥ ugc検索をする場合はreturnし、あとの処理を走らせない 20230422
    if (mas_ugc_urls_list.length > 0) {
      return;
    }

    // - 投稿の種類(最近の投稿 or 人気の投稿)を取得する
    let display_type = $('.display_type:checked').val();

    // - 表示する期間
    let initial_date = $('#mas_hashtag_initial_date').val();
    let end_date = $('#mas_hashtag_end_date').val();

    //- タググループのidとnameを取得する
    let tgg_id = $('#mas_selected_hashtag_group option:selected').val();
    let tgg_name = $('#mas_selected_hashtag_group option:selected').data('name');

    //- ハッシュタグ検索一覧ページ内に表示する投稿の数を取得する
    let per_page_num = $('#mas_per_page_num option:selected').val();

    //¥ Not条件で検索結果家から除外するハッシュタグや言葉を取得
    let excluded_words = $('#mas_excluded_words').val().trim();

    // * 改行コードを含んだ文字列を配列にする
    let excluded_word_list = excluded_words.split(/\r\n|\r|\n/);

    // 配列の中の空要素を削除し、空要素のない配列を作る
    excluded_word_list = $.grep(excluded_word_list, function (value) {
      return value != '';
    });
    if (current_url.includes('/my_post_list?')) {
      let url_query_path = `/my_post_list?display_type=${display_type}&initial_date=${initial_date}&end_date=${end_date}&per_page_num=${per_page_num}`;
      if (excluded_word_list) {
        excluded_word_list.forEach(function (excluded_word, index) {
          url_query_path = url_query_path + `&excluded_word_${index}=${excluded_word}`;
        });
      }

      // ¥ 20230424

      location.href = url_query_path;
    } else if (current_url.includes('/hashtag_list')) {
      // ¥ 投稿収集一覧用 20230320
      let url_query_path = `/hashtag_list?display_type=${display_type}&initial_date=${initial_date}&end_date=${end_date}&tgg_id=${tgg_id}&tgg_name=${tgg_name}&per_page_num=${per_page_num}`;

      selected_tag_names.forEach(function (tag_name, index) {
        url_query_path = url_query_path + `&tag_name_${index}=${tag_name}`;
      });

      selected_tag_ids.forEach(function (tag_id, index) {
        url_query_path = url_query_path + `&tag_id_${index}=${tag_id}`;
      });

      if (excluded_word_list) {
        excluded_word_list.forEach(function (excluded_word, index) {
          url_query_path = url_query_path + `&excluded_word_${index}=${excluded_word}`;
        });
      }
      location.href = url_query_path;
    }
  });

  $('.post_regist_publish_btn').on('click', function () {
    let show_hashtag = $(this).data('show_hashtag');
    let id = $(this).data('id');
    if (show_hashtag == '0') {
      $.ajax({
        url: '/show_hashtag_ok',
        type: 'POST',
        data: {
          id: id,
          show_hashtag: show_hashtag,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          location.reload();
        }
      });
    } else if (show_hashtag == '1') {
      $.ajax({
        url: '/show_hashtag_no',
        type: 'POST',
        data: {
          id: id,
          show_hashtag: show_hashtag,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          location.reload();
        }
      });
    }
  });

  // ¥ 現在選ばれている絞り込みの状態を取得 20230423
  const mas_get_all_filter_condition = function () {
    // - 投稿の種類(最近の投稿 or 人気の投稿)を取得する

    // - 表示する期間
    let initial_date = $('#mas_hashtag_initial_date').val();
    let end_date = $('#mas_hashtag_end_date').val();

    //- AND / OR 検索のidを取得する
    let search_condition = $('#mas_search_condition option:selected').val();

    //- ハッシュタグ検索一覧ページ内に表示する投稿の数を取得する
    let per_page_num = $('#mas_per_page_num option:selected').val();
    $('#mas_tag_list').remove();

    result = {
      initial_date: initial_date,
      end_date: end_date,
      search_condition: search_condition,
      per_page_num: per_page_num,
    };

    // console.log("result---- : ", result);

    return result;
  };

  //- 青木 ★要更新 - 20231227
  ////// 新規お客さんがSMMに乗り換えるときに手動で過去のUGCを登録できるようにするためにユーザー名を入力できるようにする //////
  // ¥ UGC連携 / ユーザーネーム登録のoverlay用
  $('.mas_username_input__modal_bg').on('click', function () {
    $('.mas_username_input__modal_bg').css('display', 'none');
    $('.mas_username_input__modal_container').css('display', 'none');
    $('body').css('overflow', 'auto');
  });

  // ¥ .mas_ugc_set_btnを押したときの処理 username矯正入力及び連携モーダルを出現させる
  $('.mas_ugc_set_btn')
    .off()
    .on('click', function () {
      $('body').css('overflow', 'hidden'); // Disable scrolling
      $('.mas_username_input__modal_bg').css('display', 'block');

      // ¥ username取得のためリンクを貼る
      let permalink = $(this).attr('data-permalink');
      $('.mas_username_input__redirect_url').attr('href', permalink);

      let username = $(this).attr('data-username');
      username = username ? username : '';

      $('.mas_username_input__input').val(username);

      // ¥ 初期化処理
      $('.mas_username_input__notice_message').remove();
      $('.mas_username_input__warning_message').remove();
      $('.mas_username_input__modal_submit').css({ 'pointer-events': 'auto', background: 'blue' });

      // if (username) {
      //   // $('.mas_username_input__modal_submit').css({ 'pointer-events': 'none', background: 'gray' });
      //   $('.mas_username_input__input').before("<div class='mas_username_input__notice_message'>※ユーザーネームはすでに登録されています。<br>ユーザーネームに誤りがある場合のみ<br>再登録してください。</div>");
      // } else if (!username) {
      //   $('.mas_username_input__modal_submit').css({ 'pointer-events': 'none', background: 'gray' });
      //   $('.mas_username_input__input').before("<div class='mas_username_input__warning_message'>※ユーザーネームが登録されていません。<br>登録完了後、連携ボタンを利用できます。</div>");
      // }

      $('.mas_username_input__modal_container').css('display', 'block');

      // let sns_post_id = $(this).data('id');
      let sns_post_id = $(this).data('sns_post_id');
      $('.mas_username_input__modal_submit').attr('data-sns_post_id', sns_post_id);

      // let parent_media_id = $(this).data('parent_media_id');
      // $('.mas_username_input__modal_submit').attr('data-parent_media_id', parent_media_id);

      let $this = $(this);

      // UGC group linking modal display
      $('.mas_username_input__modal_del').on('click', function () {
        $('body').css('overflow', 'auto');
        $('.mas_username_input__modal_container').css('display', 'none');
      });

      // ¥ ユーザーネームを手動登録
      $('.mas_username_input__username_submit')
        .off()
        .on('click', function () {
          let input_username = $('.mas_username_input__input').val();
          // if (!input_username) {
          //   alert(`ユーザーネームが入力されていません。`);
          //   return;
          // }
          console.log('input_username :>> ', input_username);
          $.ajax({
            url: '/mas_save_manual_ugc_username',
            type: 'POST',
            data: {
              sns_post_id: sns_post_id,
              input_username: input_username,
            },
            dataType: 'json',
          })
            .done(function (data) {
              alert('ユーザーネームを登録されました。画面を再読込みすると、画面に変更が反映されます。');
              // alert(data.success_message);
              // location.reload();
              // ¥ 連携するボタンを押せるようにする
              $('.mas_username_input__modal_submit').css({ 'pointer-events': 'auto', background: 'blue' });
              $('body').css('overflow', 'auto');
              $this.closest('.mas_tag_container').find('.mas_ugc_username > p').text(input_username);
              // ¥ カルーセルに属する全ての投稿のユーザー名を一度に変更する
              if (parent_media_id) {
                $(`div[data-parent_media_id="${parent_media_id}"]`).each((index, el) => {
                  $(el).closest('.mas_tag_container').find('.mas_ugc_username > p').text(input_username);
                });
              }
              location.reload();
            })
            .fail(function () {
              alert('ユーザーネームの登録に失敗しました。再度お試しください。');
              $('body').css('overflow', 'auto');
            });
        });

      // ¥ UGC連携(mpm用)
      $('.mas_username_input__modal_submit')
        .off()
        .on('click', function () {
          let ugc_group_ids = [];
          $('input[name=ugc_groups]:checked').each(function () {
            ugc_group_ids.push($(this).val());
          });

          if (ugc_group_ids.length == 0) {
            alert('Please select a UGC group.');
            return;
          }
          $.ajax({
            url: '/ugc_group_id_set',
            type: 'POST',
            data: {
              sns_post_id: sns_post_id,
              ugc_group_ids: ugc_group_ids,
            },
            dataType: 'json',
          })
            .done(function (data) {
              alert(`指定されたUGCグループに本投稿を連携しました。`);
            })
            .fail(function () {
              alert(
                `予期しないエラーにより、連携が失敗しました。
              お手数ですが再度お試しください。`.replace(/[ \t]/g, '')
              );
            })
            .always(function () {
              location.reload();
            });
        });

      $('.mas_username_input__modal_cancel_submit').on('click', function () {
        let ugc_group_id = $('.mas_username_input__ugc_modal_select option:selected').val();

        $.ajax({
          url: '/ugc_group_id_delete',
          type: 'POST',
          data: {
            sns_post_id: sns_post_id,
          },
          dataType: 'json',
        }).done(function (data) {
          if (data.ret == '0') {
            alert('UGC group link has been removed.');
            location.reload();
          }
        });
      });
    });
}); // end of document.addEventListener("turbolinks:load", function () {
